import { jwtDecode, JwtPayload } from 'jwt-decode';
import { Lang } from 'types/globalTypes';
import { getAuthFromLocalStorage, removeAuthFromLocalStorage } from './storage';

export const getCodeFromLang = (lang: Lang) => {
  const languages = {
    en: '1',
    km: '2',
  };

  return languages[lang];
};

export const base64ToImage = (base64String: string) => {
  const base64Data = base64String.replace(/^data:image\/\w+;base64,/, '');
  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'image/png' });

  const img = document.createElement('img');
  img.src = URL.createObjectURL(blob);
  document.body.appendChild(img);
};

export const createHrefId = (title: string) => {
  return title.toLowerCase().replace(/\s+/g, '-');
};

export const convertDateForInForce = (dateString: string) => {
  if (typeof dateString !== 'string' || !dateString.includes('-')) {
    return dateString;
  }
  const [year, month, day] = dateString.split('-');

  return `${day}.${month}.${year}`;
};

export const validateToken = async () => {
  try {
    const { token } = getAuthFromLocalStorage();
    if (!token) {
      removeAuthFromLocalStorage();
      return { isValid: false, error: 'No token provided' };
    }

    const decodedToken = jwtDecode<JwtPayload & { exp?: number }>(token);
    const currentTime = Date.now() / 1000;

    if (typeof decodedToken.exp != 'number' || decodedToken.exp < currentTime) {
      removeAuthFromLocalStorage();
      return { isValid: false, error: 'Token expired' };
    }

    return { isValid: true };
  } catch (error) {
    console.error('Error decoding token', error);
    removeAuthFromLocalStorage();
    return { isValid: false, error: 'Invalid token' };
  }
};
